module.exports = __webpack_public_path__ + "static/img/lniao_benefit_bg.1531968d.png";